import React, { createContext, useEffect, useRef, useState } from "react";
import useCart from "../hooks/useCart";
import axiosPublic from "../axios/axiosPublic";
import useGraffiti from "../hooks/useGraffiti";

export const CouponContext = createContext(null);

export const CouponProvider = ({ children }) => {
  const { cartData } = useCart();
  const { triggerGraffiti } = useGraffiti();
  const [couponData, setCouponData] = useState({
    bestCoupon: null,
    coupons: [],
    isBest: false,
    applied: false,
    appliedCoupon: null,
    suppressed: false,
  });

  // True while the HAYD wallet is in use: the best coupon is then not applied on its own.
  const suppressedRef = useRef(false);
  useEffect(() => {
    suppressedRef.current = Boolean(couponData?.suppressed);
  }, [couponData?.suppressed]);

  useEffect(() => {
    if (!cartData?.items?.length) {
      setCouponData({
        bestCoupon: null,
        coupons: [],
        isBest: false,
        applied: false,
        appliedCoupon: null,
      });
      return;
    }

    const getCoupons = async () => {
      try {
        const res = await axiosPublic.post("/coupons/get-all-coupon", {
          cartData,
        });

        const fetchedCouponData = res?.data?.data;

        // While the HAYD wallet is in use (suppressed), the best coupon is not applied on its own: HAYD does not allow
        // a coupon and the wallet together.
        const suppressed = suppressedRef.current;
        setCouponData({
          bestCoupon: fetchedCouponData?.bestCoupon,
          coupons: fetchedCouponData?.coupons,
          isBest: fetchedCouponData?.isBest,
          applied: suppressed ? false : fetchedCouponData?.isBest,
          appliedCoupon: suppressed ? null : fetchedCouponData?.bestCoupon,
          suppressed,
        });

        if (fetchedCouponData?.isBest && !suppressed) {
          triggerGraffiti();
        }
      } catch (err) {
        console.log(err);
      }
    };

    getCoupons();
  }, [cartData]);

  return (
    <CouponContext.Provider value={{ couponData, setCouponData }}>
      {children}
    </CouponContext.Provider>
  );
};
